var _path, _path2, _path3, _linearGradient, _path4, _linearGradient2, _path5, _linearGradient3, _path6, _linearGradient4, _path7, _linearGradient5, _path8, _linearGradient6, _path9, _linearGradient7, _path10, _linearGradient8, _path11, _linearGradient9, _path12, _path13, _linearGradient10, _path14, _path15, _linearGradient11, _path16, _linearGradient12, _path17, _path18, _linearGradient13, _path19, _linearGradient14, _path20, _linearGradient15, _path21, _linearGradient16, _path22, _circle, _path23, _path24, _linearGradient17, _path25, _linearGradient18, _path26, _linearGradient19, _path27, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPedigree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 1698,
    viewBox: "0 0 415.603 282.287",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.937 261.21c1.789.085 3.649.14 5.488.089l11.446-1.205c6.521-1.18 13.305-3.236 20.323-6.306 3.825 5.346 7.276 9.452 11.526 13.553l7.165 6.336a218.28 218.28 0 0 0 3.53 2.831c12.405-23.987 17.722-44.679 21.822-72.053a85.831 85.831 0 0 1-18.487 2.002c-12.597 0-24.541-2.713-35.311-7.6-5.239 22.16-14.276 43.809-27.502 62.353z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 7.524
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M282.903 257.182a120.03 120.03 0 0 1-4.855.151l-10.748-.323c-9.399-.652-18.964-2.24-28.404-4.541-4.026 5.655-8.922 10.674-13.895 15.058l-7.297 6.007a217.8 217.8 0 0 1-3.817 2.877c-2.589-5.411-5.348-10.45-8.318-15.219 7.503-18.005 11.462-35.326 14.668-56.736a85.041 85.041 0 0 0 28.135-11.793c9.801 21.503 21.22 43.024 34.531 64.519z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 7.524
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M219.138 13.153c-9.009-1.25-17.036-7.102-23.014-8.873-7.814-2.314-12.571 3.566-11.687 8.866-8.951 1.59-18.385-1.488-24.614-1.326-8.146.212-10.857 7.271-8.379 12.037-8.023 4.283-17.956 4.266-23.833 6.345-7.682 2.719-8.079 10.27-4.249 14.037-6.307 6.553-15.758 9.606-20.705 13.4-6.465 4.96-4.51 12.264.296 14.663-3.973 8.181-12.019 14.005-15.551 19.143-4.616 6.715-.5 13.057 4.813 13.854-1.25 9.009-7.103 17.034-8.875 23.011-2.315 7.813 3.56 12.573 8.859 11.688 1.595 8.955-1.491 18.395-1.329 24.627.212 8.146 7.271 10.856 12.037 8.378 4.284 8.023 4.267 17.956 6.347 23.833 2.719 7.683 10.27 8.079 14.038 4.249 6.553 6.307 9.606 15.759 13.4 20.705 4.96 6.465 12.264 4.51 14.664-.297 8.182 3.973 14.006 12.019 19.143 15.551 6.715 4.616 13.058.499 13.854-4.814 9.009 1.25 17.034 7.103 23.012 8.874 7.813 2.315 12.573-3.56 11.688-8.859 8.955-1.595 18.396 1.491 24.627 1.329 8.147-.213 10.857-7.271 8.379-12.038 8.023-4.284 17.956-4.267 23.833-6.347 7.683-2.72 8.079-10.271 4.249-14.039 6.307-6.553 15.759-9.607 20.705-13.401 6.466-4.96 4.51-12.265-.298-14.663 3.973-8.183 12.019-14.007 15.552-19.145 4.616-6.716.498-13.058-4.815-13.854 1.25-9.009 7.103-17.035 8.874-23.013 2.315-7.813-3.561-12.573-8.86-11.688-1.596-8.955 1.49-18.396 1.328-24.629-.213-8.146-7.271-10.857-12.038-8.378-4.285-8.023-4.269-17.957-6.349-23.833-2.721-7.682-10.271-8.079-14.039-4.248-6.554-6.307-9.607-15.759-13.402-20.706-4.96-6.466-12.265-4.509-14.664.298-8.182-3.973-14.007-12.019-19.145-15.55-6.714-4.617-13.056-.5-13.852 4.813z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 7.524
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: -32.448,
    y1: -6.809,
    x2: -2.448,
    y2: -6.809,
    gradientTransform: "translate(219.62 27.857) scale(1.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9e196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#e7ae76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#da7f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#d4614e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d25349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc203c"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188.336 38.008a86.326 86.326 0 0 1 13.413-1.051c4.564 0 9.042.365 13.414 1.051l3.974-24.855c-9.01-1.25-17.035-7.101-23.013-8.873-7.814-2.314-12.572 3.562-11.688 8.861l3.9 24.867z",
    fill: "url(#a)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: -1.087,
    y1: -6.609,
    x2: 27.58,
    y2: 2.724,
    gradientTransform: "translate(219.62 27.857) scale(1.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9e196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#e7ae76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#da7f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#d4614e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d25349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc203c"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M215.163 38.009a86.196 86.196 0 0 1 13.081 3.145 86.408 86.408 0 0 1 12.432 5.145l11.46-22.411c-8.183-3.973-14.006-12.018-19.144-15.549-6.716-4.616-13.057-.499-13.854 4.815l-3.975 24.855z",
    fill: "url(#b)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 29.162,
    y1: 3.382,
    x2: 51.828,
    y2: 21.382,
    gradientTransform: "translate(219.62 27.857) scale(1.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9e196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#e7ae76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#da7f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#d4614e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d25349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc203c"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M240.676 46.299a86.395 86.395 0 0 1 11.469 7.034 86.364 86.364 0 0 1 10.234 8.735l17.824-17.772c-6.555-6.307-9.607-15.758-13.402-20.705-4.96-6.466-12.264-4.509-14.663.298l-11.462 22.41z",
    fill: "url(#c)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 54.388,
    y1: 21.977,
    x2: 70.387,
    y2: 46.642,
    gradientTransform: "translate(219.62 27.857) scale(1.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9e196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#e7ae76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#da7f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#d4614e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d25349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc203c"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M262.378 62.068a86.434 86.434 0 0 1 8.735 10.233 86.438 86.438 0 0 1 7.033 11.47l22.443-11.394c-4.284-8.023-4.268-17.956-6.348-23.833-2.721-7.682-10.271-8.078-14.038-4.248l-17.825 17.772z",
    fill: "url(#d)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 72.647,
    y1: 47.424,
    x2: 80.647,
    y2: 77.424,
    gradientTransform: "translate(219.62 27.857) scale(1.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9e196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#e7ae76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#da7f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#d4614e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d25349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc203c"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M278.146 83.772a86.442 86.442 0 0 1 5.145 12.431 86.46 86.46 0 0 1 3.145 13.083l24.866-3.901c-1.596-8.954 1.49-18.395 1.328-24.627-.213-8.146-7.271-10.856-12.038-8.377l-22.446 11.391z",
    fill: "url(#e)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 210.706,
    y1: 14.656,
    x2: 244.592,
    y2: 14.656,
    gradientTransform: "rotate(90 211.275 107.29) scale(1.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9e196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#e7ae76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#da7f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#d4614e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d25349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc203c"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M286.434 109.286c.687 4.371 1.052 8.849 1.052 13.413s-.365 9.042-1.053 13.413l24.855 3.975c1.25-9.009 7.102-17.034 8.873-23.012 2.315-7.813-3.562-12.572-8.86-11.688l-24.867 3.899z",
    fill: "url(#f)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 81.39,
    y1: 109.39,
    x2: 72.723,
    y2: 137.39,
    gradientTransform: "translate(219.62 27.857) scale(1.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9e196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#e7ae76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#da7f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#d4614e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d25349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc203c"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M286.433 136.111a86.081 86.081 0 0 1-8.291 25.513l22.41 11.46c3.972-8.182 12.017-14.005 15.55-19.143 4.616-6.716.498-13.057-4.815-13.854l-24.854-3.976z",
    fill: "url(#g)"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 71.922,
    y1: 138.952,
    x2: 53.922,
    y2: 162.285,
    gradientTransform: "translate(219.62 27.857) scale(1.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9e196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#e7ae76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#da7f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#d4614e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d25349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc203c"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M278.142 161.624c-2.014 3.939-4.351 7.776-7.033 11.469s-5.61 7.101-8.735 10.232l17.771 17.825c6.307-6.554 15.758-9.607 20.704-13.401 6.466-4.96 4.509-12.264-.298-14.663l-22.409-11.462z",
    fill: "url(#h)"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: -461.776,
    y1: 165.1,
    x2: -485.777,
    y2: 180.434,
    gradientTransform: "translate(745.962 27.857) scale(1.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9e196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#e7ae76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#da7f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#d4614e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d25349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc203c"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M262.374 183.325a86.124 86.124 0 0 1-21.703 15.766l11.393 22.444c8.023-4.284 17.955-4.267 23.832-6.347 7.683-2.72 8.078-10.271 4.248-14.038l-17.77-17.825z",
    fill: "url(#i)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M240.669 199.092a86.391 86.391 0 0 1-12.431 5.144 86.447 86.447 0 0 1-13.082 3.145l3.9 24.865c8.955-1.595 18.395 1.491 24.626 1.329 8.147-.213 10.856-7.271 8.378-12.038l-11.391-22.445z",
    fill: "#cc203c"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: -578.374,
    y1: 181.481,
    x2: -602.375,
    y2: 163.48,
    gradientTransform: "translate(745.962 27.857) scale(1.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9e196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#e7ae76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#da7f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#d4614e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d25349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc203c"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M162.82 199.086c-3.939-2.014-7.776-4.352-11.468-7.034s-7.101-5.61-10.232-8.735l-17.825 17.771c6.553 6.308 9.606 15.758 13.4 20.704 4.96 6.465 12.263 4.509 14.663-.298l11.462-22.408z",
    fill: "url(#j)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M188.266 207.119a86.348 86.348 0 0 1-13.081-3.146 86.446 86.446 0 0 1-12.431-5.146l-11.46 22.408c8.182 3.973 14.005 12.018 19.142 15.55 6.715 4.616 13.056.499 13.853-4.813l3.977-24.853z",
    fill: "#cc203c"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: -89.327,
    y1: 162.405,
    x2: -107.328,
    y2: 138.405,
    gradientTransform: "translate(219.62 27.857) scale(1.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9e196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#e7ae76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#da7f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#d4614e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d25349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc203c"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M141.119 183.316a86.326 86.326 0 0 1-8.733-10.233 86.261 86.261 0 0 1-7.032-11.47l-22.443 11.393c4.284 8.022 4.266 17.954 6.346 23.831 2.719 7.683 10.27 8.078 14.037 4.248l17.825-17.769z",
    fill: "url(#k)"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: -107.323,
    y1: 137.829,
    x2: -116.657,
    y2: 108.494,
    gradientTransform: "translate(219.62 27.857) scale(1.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9e196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#e7ae76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#da7f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#d4614e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d25349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc203c"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M125.354 161.612a86.505 86.505 0 0 1-5.144-12.431 86.414 86.414 0 0 1-3.144-13.082L92.202 140c1.595 8.955-1.491 18.394-1.329 24.626.212 8.146 7.271 10.855 12.037 8.378l22.444-11.392z",
    fill: "url(#l)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M117.067 136.1a86.313 86.313 0 0 1-1.05-13.412c0-4.564.366-9.042 1.053-13.413L92.217 105.3c-1.25 9.009-7.103 17.033-8.874 23.01-2.315 7.813 3.56 12.571 8.859 11.687l24.865-3.897z",
    fill: "#cc203c"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: -115.594,
    y1: 76.451,
    x2: -108.261,
    y2: 47.784,
    gradientTransform: "translate(219.62 27.857) scale(1.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9e196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#e7ae76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#da7f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#d4614e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d25349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc203c"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M117.07 109.275c.698-4.369 1.735-8.74 3.146-13.08s3.142-8.486 5.146-12.431l-22.408-11.461c-3.973 8.181-12.018 14.004-15.55 19.142-4.616 6.715-.499 13.056 4.814 13.853l24.852 3.977z",
    fill: "url(#m)"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: -106.082,
    y1: 45.548,
    x2: -88.749,
    y2: 21.548,
    gradientTransform: "translate(219.62 27.857) scale(1.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9e196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#e7ae76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#da7f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#d4614e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d25349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc203c"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M125.362 83.765a86.415 86.415 0 0 1 7.034-11.467 86.343 86.343 0 0 1 8.735-10.232l-17.77-17.825c-6.307 6.553-15.757 9.605-20.704 13.399-6.465 4.96-4.51 12.263.297 14.662l22.408 11.463z",
    fill: "url(#n)"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: -88.057,
    y1: 20.855,
    x2: -63.39,
    y2: 4.189,
    gradientTransform: "translate(219.62 27.857) scale(1.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9e196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#e7ae76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#da7f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#d4614e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d25349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc203c"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M141.132 62.065a86.5 86.5 0 0 1 10.233-8.733 86.325 86.325 0 0 1 11.47-7.032l-11.391-22.443c-8.023 4.284-17.955 4.266-23.832 6.345-7.682 2.719-8.078 10.269-4.248 14.037l17.768 17.826z",
    fill: "url(#o)"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: -61.754,
    y1: 2.351,
    x2: -33.753,
    y2: -5.65,
    gradientTransform: "translate(219.62 27.857) scale(1.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9e196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#e7ae76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#da7f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#d4614e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d25349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc203c"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M162.835 46.301a86.34 86.34 0 0 1 12.431-5.143 86.336 86.336 0 0 1 13.081-3.143l-3.898-24.865c-8.954 1.594-18.394-1.492-24.625-1.33-8.146.212-10.856 7.271-8.378 12.037l11.389 22.444z",
    fill: "url(#p)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 201.75,
    cy: 122.696,
    r: 85.837,
    fill: "#cc203c"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M138.937 261.21c1.789.085 3.649.14 5.488.089l11.446-1.205c6.521-1.18 13.305-3.236 20.323-6.306 3.825 5.346 7.276 9.452 11.526 13.553l7.165 6.336a218.28 218.28 0 0 0 3.53 2.831c12.405-23.987 17.722-44.679 21.822-72.053a85.831 85.831 0 0 1-18.487 2.002c-12.597 0-24.541-2.713-35.311-7.6-5.239 22.16-14.276 43.809-27.502 62.353z",
    fill: "#cc203c"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M282.903 257.182a120.03 120.03 0 0 1-4.855.151l-10.748-.323c-9.399-.652-18.964-2.24-28.404-4.541-4.026 5.655-8.922 10.674-13.895 15.058l-7.297 6.007a217.8 217.8 0 0 1-3.817 2.877c-2.589-5.411-5.348-10.45-8.318-15.219 7.503-18.005 11.462-35.326 14.668-56.736a85.041 85.041 0 0 0 28.135-11.793c9.801 21.503 21.22 43.024 34.531 64.519z",
    fill: "#cc203c"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 187.625,
    y1: 209.12,
    x2: 173.289,
    y2: 262.366
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2ca30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    stopColor: "#f4ce45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#fae5a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fceec7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753,
    stopColor: "#f9e19b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#f4d15e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2ca44"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M155.888 260.102c-3.912.708-7.76 1.119-11.476 1.225 12.604-18.17 21.302-39.127 26.386-60.636a85.06 85.06 0 0 0 8.751 2.864c-4.705 19.904-12.533 39.355-23.661 56.547zm31.883 7.22a119.22 119.22 0 0 0 7.115 6.344c11.678-22.802 16.971-42.719 20.97-68.362a85.88 85.88 0 0 1-9.576 1.038c-3.697 22.556-8.69 40.816-18.509 60.98z",
    fill: "url(#q)"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 236.085,
    y1: 216.974,
    x2: 242.912,
    y2: 256.567
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2ca30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    stopColor: "#f4ce45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#fae5a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fceec7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753,
    stopColor: "#f9e19b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#f4d15e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2ca44"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M236.481 199.105a85.841 85.841 0 0 0 8.06-4.097c9.543 20.799 20.654 41.565 33.486 62.352-3.548.039-7.114-.094-10.728-.344-11.711-19.299-21.93-38.602-30.818-57.911zm-18.766 74.402c2.388-1.849 4.833-3.805 7.278-5.961-3.975-8.16-8.746-16.114-13.474-22.738a185.9 185.9 0 0 1-3.738 10.878c3.614 5.518 6.871 11.43 9.934 17.821z",
    fill: "url(#r)"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 144.005,
    y1: 101.904,
    x2: 307.432,
    y2: 101.904,
    gradientTransform: "translate(-33.846 17.285) scale(1.0342)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#fefcf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#fcf4d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#f9e8a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218,
    stopColor: "#f5d761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#f2ca30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#f3cd3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#f5d660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    stopColor: "#f9e598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fdf8e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#fae9b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#f4d363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2ca44"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M275.643 97.138c-10.583-30.633-39.675-52.635-73.905-52.635-43.172 0-78.17 34.999-78.17 78.17s34.999 78.171 78.17 78.171c35.718 0 65.84-23.957 75.178-56.678l7.387 4.215c-10.946 35.191-43.772 60.743-82.565 60.743-47.745 0-86.451-38.707-86.451-86.451 0-47.745 38.706-86.451 86.451-86.451 38.039 0 70.34 24.568 81.902 58.703l-7.997 2.213z",
    fill: "url(#s)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M405.015 84.084h-1.637v-9.962h3.778c2.406 0 3.634.842 3.634 2.863 0 1.805-1.107 2.551-2.6 2.719l2.792 4.379h-1.854l-2.574-4.259h-1.54v4.26zm1.829-5.655c1.227 0 2.31-.12 2.31-1.564 0-1.203-1.179-1.348-2.165-1.348h-1.974v2.912h1.829zm-.049 9.505c-5.174 0-8.854-3.874-8.854-9 0-5.414 4.091-9 8.854-9 4.717 0 8.808 3.585 8.808 9s-4.091 9-8.808 9zm0-16.435c-3.898 0-6.93 3.056-6.93 7.436 0 4.091 2.646 7.436 6.93 7.436 3.851 0 6.883-3.032 6.883-7.436 0-4.38-3.032-7.436-6.883-7.436z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M394.502 89.51c-5.524-5.88-12.879-8.989-21.267-8.989-7.831 0-15.002 3.032-20.739 8.769-2.816 2.817-5.225 6.28-7.133 10.13-1.618-3.936-3.782-7.39-6.465-10.245-5.524-5.88-12.878-8.989-21.267-8.989-7.83 0-15.001 3.032-20.737 8.769a33.94 33.94 0 0 0-2.384 2.668c-.854-2.645-2.254-5.039-4.142-6.927-2.801-2.801-6.462-4.343-10.307-4.343-2.026 0-3.939.347-5.704 1.001h-21.312c-2.533 0-3.727-.641-7.215-.641-4.038 0-7.406.847-9.634 1.867-.264.121-.577.263-.847.381-.794-.126-1.791-.45-2.989-.845-2.902-.956-6.875-2.266-12.578-2.266-8.294 0-15.908 2.981-21.506 8.393v-.509l.001-7.216h-7.795c3.909-2.892 6.481-8.125 6.481-14.242 0-5.086-1.794-9.798-4.923-12.926-2.4-2.4-5.476-3.723-8.66-3.723s-6.259 1.322-8.66 3.723c-3.128 3.128-4.923 7.839-4.923 12.926 0 5.086 1.794 9.797 4.923 12.926.488.488 1.01.919 1.549 1.316h-7.217l.002-33.395-33.962.002V65.92h2.416a3.253 3.253 0 0 1 3.254 3.249v10.788a27.474 27.474 0 0 0-5.806-.609c-6.789 0-12.941 2.564-17.792 7.416-2.327 2.328-4.292 5.1-5.892 8.303-1.418-2.766-3.128-5.255-5.141-7.397-5.524-5.881-12.878-8.989-21.267-8.989-5.537 0-10.741 1.523-15.345 4.44-.181-9.231-3.597-17.828-9.454-23.684-4.997-4.998-11.376-7.636-18.448-7.636H.011V70.6h2.416a3.242 3.242 0 0 1 3.241 3.25v62.335a3.252 3.252 0 0 1-3.252 3.249H0v18.795h45.33v-18.767l-6.943.001a3.25 3.25 0 0 1-3.249-3.249l.005-17.057h2.472c5.235 0 10.202-1.177 14.582-3.387-.053.895-.089 1.79-.089 2.685 0 13.678 4.193 25.716 11.503 33.025 5.506 5.507 12.742 8.418 20.925 8.418 8.475 0 15.934-2.932 21.57-8.48a30 30 0 0 0 4.973-6.473c1.558 2.995 3.456 5.645 5.68 7.869 4.854 4.853 10.975 7.418 17.702 7.418 1.495 0 4.53-.087 7.996-1.085h48.416a27.375 27.375 0 0 0-.174 3.056c0 5.787 2.147 10.993 6.208 15.056 5.356 5.356 13.441 8.187 23.38 8.187 18.515 0 31.896-10.309 33.974-25.547h29.337v-18.795h-2.416a3.25 3.25 0 0 1-3.249-3.249l-.009-18.697h6.969c-.005.267-.02.534-.02.8 0 13.679 4.192 25.716 11.503 33.026 5.507 5.508 12.741 8.418 20.924 8.418 8.476 0 15.935-2.932 21.571-8.48 2.7-2.658 4.857-5.795 6.428-9.31 1.781 3.759 4.021 7.049 6.68 9.707 5.506 5.507 12.742 8.417 20.924 8.417 8.475 0 15.934-2.933 21.57-8.479 5.389-5.303 8.613-12.504 9.328-20.826l.513-9.184c.879-14.083-2.605-26.065-9.812-33.737zM35.645 97.332V72.128c1.055 0 3.105 5.801 3.105 12.602 0 6.279-1.957 12.602-3.105 12.602zm337.384 4.594c1.392 0 2.148 3.226 2.148 7.315h-4.479c.001-3.228.876-7.315 2.331-7.315zm1.094 39.374c-2.651 0-4.091-6.927-4.091-11.286h8.656c0 4.906-1.848 11.286-4.565 11.286z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.663 100.089c1.392 0 2.147 3.226 2.147 7.315h-4.479c.001-3.227.877-7.315 2.332-7.315zM85.756 139.464c-2.651 0-4.091-6.928-4.091-11.287h8.657c0 4.906-1.848 11.287-4.566 11.287zM220.002 99.749c1.229 0 1.455 3.697 1.455 8.257s-.227 8.257-1.455 8.257-1.456-3.697-1.456-8.257c.001-4.561.228-8.257 1.456-8.257zM198.164 141.775c-.788 0-1.401-.949-1.401-1.546l.003-13.389a23.035 23.035 0 0 0 3.281 3.298c-1.224 2.391-1.944 5.129-2.054 8.081-.045 1.21.018 2.4.171 3.556zM219.53 165.004c-6.061 0-7.389-2.771-6.71-5.664 1.688.567 4.523.964 6.943.964 3.645 0 6.395-.888 8.35-.735 1.079.085 1.314.613 1.314 1.338 0 2.275-5.031 4.097-9.897 4.097zM249.792 141.002c-2.326-3.291-6.7-7.201-9.874-8.272 3.505-2.309 8.409-8.075 9.874-13.18v21.452zM317.426 101.592c1.392 0 2.147 3.226 2.147 7.315h-4.479c.001-3.228.877-7.315 2.332-7.315zM318.52 140.967c-2.651 0-4.091-6.928-4.091-11.287h8.656c0 4.906-1.848 11.287-4.565 11.287zM140.438 130.62c0 4.302-.27 6.831-2.038 6.831-2.806 0-3.569-8.554-3.569-16.905 0-4.554.877-12.059 2.539-15.767.294-.656.723-1.146 1.485-1.146.68 0 1.261.38 1.384 1.169.193 1.241.199 2.954.199 5.008v20.81zM170.849 139.8c0 2.004-2.504 2.171-2.504.167V97.889c1.001 0 2.504 1.169 2.504 2.838V139.8z",
    fill: "#cc203c"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.236 87.735c-16.421 0-25.548 17.475-25.548 32.56 0 16.865 7.18 34.23 25.213 34.23 13.546 0 22.578-9.518 23.711-22.708h-10.854c-.777 7.791-3.622 16.697-11.688 16.697-10.295 0-11.521-14.636-11.521-25.713h34.563c1.337-21.374-8.348-35.066-23.876-35.066zm9.349 28.72h-19.87c0-8.125 3.063-22.208 10.354-22.208 7.231.001 9.908 9.91 9.516 22.208zM317.632 87.401c-16.421 0-25.548 17.475-25.548 32.56 0 16.865 7.181 34.23 25.214 34.23 13.546 0 22.578-9.517 23.71-22.708h-10.853c-.777 7.79-3.622 16.696-11.688 16.696-10.295 0-11.521-14.636-11.521-25.713h34.564c1.335-21.373-8.348-35.065-23.878-35.065zm9.351 28.721h-19.87c0-8.125 3.063-22.208 10.353-22.208 7.232 0 9.909 9.908 9.517 22.208zM231.807 138.162c-2.839 0-11.021.5-12.857.5-4.952 0-7.681-2.17-7.681-5.176 0-1.67.835-2.003 1.67-3.173 14.193 4.446 31.057-3.778 31.057-19.536 0-11.521-3.339-12.189-3.339-15.362 0-1.493 2.401-2.505 5.151-2.505v-4.34c-5.07 0-7.423 1.669-9.827 1.669-4.675 0-8.182-3.172-16.197-3.172-12.466 0-23.042 8.683-23.042 22.542 0 8.87 4.232 16.066 12.022 19.035-6.929 4.503-6.152 15.868-1.335 19.536-5.458 2.339-9.518 5.954-9.518 14.027 0 9.407 8.406 16.029 22.375 16.029 14.417 0 27.051-7.738 27.051-22.542-.001-9.46-7.792-17.532-15.53-17.532zm-11.521-46.085c5.401 0 8.015 8.458 8.015 15.529 0 9.293-3.397 16.197-8.349 16.197-5.401 0-8.182-8.125-8.182-16.364s3.005-15.362 8.516-15.362zm-.167 80.148c-10.963 0-14.694-5.734-14.694-12.355 0-3.507 2.505-7.014 6.345-8.85 6.011 3.673 12.356 1.335 16.364 1.335 4.508 0 8.516 2.948 8.516 8.85-.001 6.788-8.683 11.02-16.531 11.02zM84.869 85.899c-16.421 0-25.547 17.475-25.547 32.56 0 16.865 7.18 34.229 25.213 34.229 13.545 0 22.578-9.517 23.71-22.708H97.392c-.778 7.791-3.621 16.698-11.688 16.698-10.295 0-11.521-14.636-11.521-25.714h34.564c1.335-21.373-8.35-35.065-23.878-35.065zm9.35 28.72h-19.87c0-8.125 3.063-22.208 10.353-22.208 7.232 0 9.909 9.909 9.517 22.208zM37.615 111.947c12.8 0 24.712-8.85 24.712-28.052 0-12.523-7.571-24.876-20.705-24.876H7.225v4.371c3.142 0 5.668 2.547 5.668 5.688v71.885a5.681 5.681 0 0 1-5.68 5.689v4.367h30.902v-4.341h-4.504a5.689 5.689 0 0 1-5.688-5.689l.007-29.042h9.685zm-9.184-47.505h6.679c7.29 0 10.853 10.378 10.853 20.288 0 11.688-4.675 21.373-12.69 21.373-4.007 0-4.842-1.946-4.842-7.514V64.442zM161.839 141.991l.006-87.651-19.533.002v4.368a5.676 5.676 0 0 1 5.674 5.688v27.845c-3.12-3.898-7.957-5.677-13.024-5.677-11.297 0-21.707 9.961-21.707 35.398 0 17.866 8.239 31.057 21.206 31.057 4.879 0 9.424-1.012 12.857-5.176v4.091h20.207v-4.258a5.683 5.683 0 0 1-5.686-5.687zm-14.188-10.341c0 8.125-3.005 13.024-9.351 13.024-8.072 0-10.687-11.078-10.687-23.544 0-11.579 3.115-25.38 11.521-25.38 6.493 0 8.516 6.088 8.516 14.308l.001 21.592z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.384,
    cy: 66.279,
    rx: 6.368,
    ry: 9.434
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.052 141.798l.013-54.062h-19.536v4.341h1.336c1.894 0 4.495 1.947 4.495 6.011v43.761c0 3.142-2.699 5.68-5.841 5.68l.01 4.409h25.203l.009-4.451a5.69 5.69 0 0 1-5.689-5.689zM280.063 87.568c-4.873 0-8.143 3.486-9.354 8.523V88.57h-19.534v4.341h1.337c1.894 0 4.495 1.946 4.495 6.011v43.761c0 3.142-2.699 5.68-5.841 5.68l.009 4.325h25.208v-4.367a5.676 5.676 0 0 1-5.674-5.688v-40.609a3.743 3.743 0 0 1 3.743-3.743c2.066 0 3.759 1.676 3.759 3.743v9.923h10.034v-14.36c0-5.51-3.506-10.019-8.182-10.019z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedigree);
export default __webpack_public_path__ + "static/media/pedigree.f6dd75a43d083d02c27143076858e92c.svg";
export { ForwardRef as ReactComponent };